<template>
  <div class="edit-modal-window" :class="{mobile : isMobileDevice}">
    <div class="container">
      <div class="header">
        <span class="edit-modal-window-title clickable" @click="copyTitleToClipboard()">
          Редактирование доски
          <i>{{id}}</i>
        </span>
        <font-awesome-icon class="close-icon" icon="window-close" size="lg" @click="cancel()" />
      </div>
      <EditBoardContent class="board-content" :board="editingBoard" @cancel="cancel()" />

      <div class="buttons">
        <Button title="Сохранить" class="green" @click="save()" icon="save" />
        <Button title="Отменить" class="red" @click="cancel()" icon="times" />
        <Button
          :title="archived ? 'Из архива' : 'В архив'"
          class="archive gray"
          @click="archive()"
          icon="archive"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import EditBoardContent from "./EditBoardContent.vue";
import urlManager from "../../../common/urls";
import SimpleClipboard from "../../../common/simpleClipboard";
import clickHelper from "@/common/clickHelper.js";

export default {
  name: "EditBoard",
  props: ["board"],
  components: { EditBoardContent },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    id() {
      if (!this.board) return 0;

      return this.board.id;
    },
    archived() {
      if (!this.board) {
        return false;
      }

      return this.board.archived;
    }
  },
  created() {
    this.$eventHub.$on("command-save", this.save);
    this.$eventHub.$on("command-cancel", this.cancel);
  },
  beforeDestroy() {
    this.$eventHub.$off("command-save");
    this.$eventHub.$off("command-cancel");
  },
  methods: {
    copyTitleToClipboard() {
      if (!this.board) return;

      if (!clickHelper.isRealClick()) return;

      new SimpleClipboard().copyText(urlManager.getBoardUrl(this.board));
      this.$snotify.success(`Ссылка на доску ${this.board.id} скопирована`, {
        timeout: 1000,
        showProgressBar: false
      });
    },
    areEqual(bf1, bf2) {
      if (bf1.description != bf2.description) return false;

      if (bf1.suffix != bf2.suffix) return false;

      if (bf1.show_total != bf2.show_total) return false;

      if (bf1.show_on_card != bf2.show_on_card) return false;

      if (bf1.type != bf2.type) return false;

      return true;
    },
    cancel() {
      this.$emit("cancel");
    },
    save() {
      if (!this.editingBoard) {
        this.$emit("cancel");
        return;
      }

      if (this.editingBoard.title != this.board.title) {
        this.$store.dispatch("boards/editTitle", {
          board: this.board,
          title: this.editingBoard.title
        });
      }
      this.editingBoard.fields.forEach(ebf => {
        if (ebf.new) {
          if (ebf.description) {
            this.$store.dispatch("fieldsInt/new", {
              board: this.board,
              ...ebf
            });
          }
          return;
        }

        const bf = this.board.fields.find(f => f.id == ebf.id);
        if (!bf) {
          //maybe it was removed..
          return;
        }

        if (this.areEqual(bf, ebf)) {
          return;
        }

        this.$store.dispatch("fieldsInt/edit", {
          field: ebf,
          ...ebf
        });
      });

      this.editingBoard.fieldsTxt.forEach(ebf => {
        if (ebf.new) {
          if (ebf.description) {
            this.$store.dispatch("fieldsTxt/new", {
              board: this.board,
              ...ebf
            });
          }
          return;
        }

        const bf = this.board.fieldsTxt.find(f => f.id == ebf.id);
        if (!bf) {
          //maybe it was removed..
          return;
        }

        if (this.areEqual(bf, ebf)) {
          return;
        }

        this.$store.dispatch("fieldsTxt/edit", { field: ebf, ...ebf });
      });

      this.cancel();
    },
    archive() {
      const _this = this;
      if (this.board.archived) {
        this.$modal.show("ConfirmationDialog", {
          message: "Точно убрать доску <b>из архива</b>?",
          yes: () => {
            this.$store.dispatch("boards/dearchive", this.board);
            _this.cancel();
          }
        });
      } else {
        this.$modal.show("ConfirmationDialog", {
          message:
            "Точно переместить доску в <b>Архив</b>?<br>Она больше не будет доступна!",
          yes: () => {
            this.$store.dispatch("boards/archive", this.board);
            _this.cancel();
          }
        });
      }
    }
  },
  data() {
    return {
      editingBoard: null
    };
  },
  watch: {
    board: {
      handler: function(newBoard) {
        if (!newBoard) {
          this.editingBoard = null;
          return;
        }
        const clone = Object.assign({}, newBoard);
        clone.fields = this.board.fields.map(bf => Object.assign({}, bf));
        clone.fieldsTxt = this.board.fieldsTxt.map(bf => Object.assign({}, bf));

        this.editingBoard = clone;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.mobile {
  overflow-y: auto;
}

.container {
  margin: 0 0.5em;
  border-radius: 10px;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-gap: 0.5em;
  grid-template-areas:
    "header"
    "board-content"
    "buttons";
}

.header {
  margin-top: 0.5em;
  grid-area: header;
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 2em;
  grid-template-areas: "tabs close";
}

.active {
  background: #4caf50;
  font-weight: bold;
}

.close-icon {
  grid-area: close;
  width: 1.5em;
  height: 1.5em;
  cursor: pointer;
}

.close-icon:hover {
  opacity: 0.8;
}

.tab-content {
  grid-area: tabcontent;
  padding: 0.5em;
}

.tab-content-history {
  overflow: auto;
}

.buttons {
  grid-area: buttons;
  display: grid;
  grid-gap: 0.2em;
  grid-template-rows: 1fr;
  grid-template-columns: 10fr 10fr 10fr;
  margin-bottom: 0.5em;
}
</style>


